import 'idempotent-babel-polyfill'
import { checkout } from './lib/checkout'
import { drawButton } from './lib/drawButton'
import { enableLogging } from './lib/logging'
import bootstrap from './bootstrap'
// FIXME: remove polyfills when Safari 15 is released (Q4 2021)
import 'allsettled-polyfill' // necessary allSettled polyfill for sdk-aggregator
import 'polyfill-object.fromentries' // necessary Object.forEntries polyfill for sdk-aggregator

// Public interface
export const merchant = {
  checkout,
  drawButton,
  enableLogging
}

// Attach Merchant.js to the merchant page
window.masterpass = merchant

// Bootstrap Merchant.js
bootstrap()
